var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2 justify-center w-100 h-100 align-center d-flex"},[_c('div',{staticClass:"text-h2 text-center"},[_vm._v("Hello "+_vm._s(_vm.account.name)+"!")])])}
var staticRenderFns = []

export { render, staticRenderFns }